import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouGetSection() {
  return <section className="w-full bg-white py-14 md:py-[88px] px-6 lg:px-12" data-id="element-243">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-[45%_55%] gap-12 items-center" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative flex justify-center" data-id="element-245">
          <div className="absolute inset-0 bg-gradient-to-tr from-crema to-white rounded-full blur-3xl opacity-50 -z-10" data-id="element-246"></div>
          <img src="https://cdn.magicpatterns.com/uploads/pU6E1WwrC6wKn2oX29uS6U/Publidad_-02-B.png" alt="Libro Marta, Don Raúl y la IA" className="w-full max-w-md h-auto object-contain drop-shadow-[0_20px_30px_rgba(0,0,0,0.2)]" data-id="element-247" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col" data-id="element-248">
          <span className="font-sans font-bold text-[11px] text-gold uppercase tracking-wider" data-id="element-249">
            LO QUE RECIBES HOY
          </span>

          <h2 className="text-[28px] font-serif font-bold text-navy mt-2 leading-[1.3]" data-id="element-250">
            El libro que alguien debió escribir hace 3 años
          </h2>

          <p className="text-[18px] font-sans text-[#4A4A4A] mt-3 leading-[1.7]" data-id="element-251">
            100 páginas de historias reales y explicaciones humanas. Escrito
            como una conversación, no como un manual. Para quien prefiere una
            buena historia antes que una lista de pasos.
          </p>

          <ul className="mt-6 space-y-5" data-id="element-252">
            <li className="flex items-start" data-id="element-253">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-254">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-255">
                El libro completo en PDF — páginas listas para leer en cualquier
                dispositivo.
              </span>
            </li>
            <li className="flex items-start" data-id="element-256">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-257">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-258">
                6 historias reales de personas mayores de 40 que pasaron del
                miedo a usar la IA con confianza.
              </span>
            </li>
            <li className="flex items-start" data-id="element-259">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-260">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-261">
                Las 28 preguntas sobre IA que siempre quisiste hacer,
                respondidas con claridad y sin tecnicismos.
              </span>
            </li>
            <li className="flex items-start" data-id="element-262">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-263">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-264">
                Guía paso a paso para usar ChatGPT en tu vida diaria y
                profesional desde el primer día.
              </span>
            </li>
            <li className="flex items-start" data-id="element-265">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-266">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-267">
                Preguntas listas para copiar y usar con cualquier herramienta de
                IA — sin tener que pensar cómo empezar.
              </span>
            </li>
            <li className="flex items-start" data-id="element-268">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-269">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-270">
                Mini diccionario de IA con analogías cotidianas para entender
                cada término sin esfuerzo.
              </span>
            </li>
            <li className="flex items-start" data-id="element-271">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-272">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-273">
                Apéndice de consulta permanente — vuelve a él cada vez que
                escuches una palabra nueva.
              </span>
            </li>
            <li className="flex items-start" data-id="element-274">
              <span className="text-gold mr-3 mt-0.5 text-lg" data-id="element-275">&rarr;</span>
              <span className="text-[18px] font-sans text-[#4A4A4A] leading-[1.65]" data-id="element-276">
                Acceso inmediato tras la compra — sin esperas, sin envíos, sin
                complicaciones.
              </span>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}